import React, { useContext, useEffect } from "react";
import Style from "./courses.module.scss";
import { OpenInNew } from "@mui/icons-material";

import {
  StudentNotification,
  StudentCourse,
  StudentSideMenu,
  DashBar,
} from "../../../layout/Dashboard";
import { ThemeContext } from "../../../context/theme/ThemeContext";
import { authGetRequest } from "../../../api/laravel/public/api";
import { toast } from "react-toastify";
import { errorMessage } from "../../../utils/notification";
import { Company, Footer, MenuBar } from "../../../layout/welcome";
import { useHistory } from "react-router-dom";
import { _retrieveData } from "../../../utils/local-storage";
import { HeaderText } from "../../../components";
import { Link } from "react-router-dom";
import { settingContext } from "../../../context/Setting/Setting";

const Courses = () => {
  const { theme, changeTheme } = useContext(ThemeContext);
  const { page, loading } = React.useContext(settingContext);
  const [data, setData] = React.useState({});
  const [dash, setDash] = React.useState({});
  const [isPageLoader, setPageLoader] = React.useState(false);
  const [user, setUser] = React.useState({});
  const [event, setEvent] = React.useState({});
  const [inbox, setInbox] = React.useState({});
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  React.useEffect(() => {
    checkUser();
    dashboardGet();
  }, []);

  React.useEffect((e) => {
    eventsGet();
    getInbox();
  }, []);

  const eventsGet = async (e) => {
    // // setPageLoader(true);
    // const { data_r, isError } = await authGetRequest(`/account/events`);
    // if (isError) {
    //   // errorMessage(toast, data_r?.message);
    //   setPageLoader(false);
    //   return false;
    // }
    // setEvent(data_r);
    // setPageLoader(false);
  };

  const getInbox = async () => {
  //   let resp = await authGetRequest(`/account/inbox`);
  //   setInbox(resp.data_r);
  };

  const checkUser = async () => {
    let userData = await _retrieveData('user_info')
    if (!userData) {
      history.push("/auth/login");
    }
    else {
      setUser(userData);
    }
  }

  React.useEffect(() => {
    coursesGet();
  }, []);

  const coursesGet = async () => {
    setPageLoader(true);
    const { data_r, isError } = await authGetRequest(`/account/courses`);
    if (isError) {
      // errorMessage(toast, data_r?.message);
      setPageLoader(false);
      return false;
    }
    setData(data_r);
    setPageLoader(false);
  };

  const dashboardGet = async () => {
    
    const { data_r, isError } = await authGetRequest(`/account/dashboard`);
    if (isError) {
      // errorMessage(toast, data_r?.message);
      // setPageLoader(false);
      return false;
    }
    setDash(data_r);
    // setPageLoader(false);
  };

  return (
   <div id="page-top" class="home">
      <div id="page-wrap">
        <MenuBar event={event} inbox={inbox} menuIndex="auth" setting={page?.setting} loader={isPageLoader} />
        <section className="profile-feature">
          <div className="awe-parallax bg-profile-feature" style={{ backgroundImage: 'url(../img/bg.jpg)' }} />
          <div className="awe-overlay overlay-color-3" />
          <div className="container">
            <div className="info-author">
              <div className="image">
                <img src={user?.image ? process.env.REACT_APP_LOCAL_FILE_PATH + "profile/medium/" + user.image : user?.gender === "male" ? '/static/media/male.png' : '/static/media/female.png'} alt="" />
              </div>
              <div className="name-author">
                <h2 className="big">{user?.first_name} {user?.last_name}</h2>
              </div>
              <div className="address-author">
                <i className="fa fa-map-marker" />
                <h3>{user?.country}</h3>
              </div>
            </div>
            <div className="info-follow">
              <div className="trophies">
                <span>{dash?.cert_count}</span>
                <p>Certificates</p>
              </div>
              <div className="trophies">
                <span>{dash?.count_course}</span>
                <p>Courses</p>
              </div>
              <div className="trophies">
                <span>{dash?.count_active_course}</span>
                <p>Active Course</p>
              </div>
              <div className="trophies">
                <span>{dash?.complete_course}</span>
                <p>Completed Course</p>
              </div>
            </div>
          </div>
        </section>

        <section className="content-bar">
          <div className="container">
            <ul style={{ width: '100%' }}>
              <li >
                <Link to="/student/home">
                  <i className="icon mdi mdi-book-open" />
                  Learning
                </Link>
              </li>
              <li className="current">
                <Link to="/student/courses">
                  <i className="icon mdi mdi-note" />
                  Courses
                </Link>
              </li>
              <li>
                <Link to="/student/calendar">
                  <i className="icon mdi mdi-calendar" />
                  Events
                </Link>
              </li>

              <li>
                <Link to="/student/profile">
                  <i className="icon mdi mdi-account" />
                  Profile
                </Link>
              </li>
              <li>
                <Link to="/student/inbox">
                  <i className="icon mdi mdi-gmail" />
                  Inbox
                </Link>
              </li>
            </ul>
          </div>
        </section>

        <section id="course-concern" className="course-concern">
          <div className="container mt-4">
            <HeaderText text={"Active Course"} />
            <div className="row">
              {data?.total_course?.map((item, index) => {
                if (index < 3)
                  return (
                    <StudentCourse
                      item={item.courses[0]}
                      list={4}
                      link={
                        item?.courses[0]
                          ? "/student/course/" + item.courses[0].uuid
                          : ""
                      }
                      progress={item.progress}
                      key={index}
                    />
                  )
              })}
            </div>
          </div>
          <div className="container mb-4">
            <HeaderText text={"Register New Course"} />
            <div className="row">
              {data?.related_course?.map((item, index) => {
                if (
                  index < 3 &&
                  data?.total_course.findIndex((it) => it.course_id != item.id)
                )
                  return (
                    <StudentCourse
                      item={item}
                      list={4}
                      link={item ? "/course/" + item?.uuid : ""}
                      progress={null}
                      key={index}
                    />
                  )
              })}
            </div>
          </div>
          <div className="container mb-4">
            <HeaderText text={"Completed Course"} />
            <div className="row">
              {data?.completed_course?.map((item, index) => {
                if (
                  index < 3 
                )
                  return (
                    <StudentCourse
                      item={item.courses[0]}
                      list={4}
                      link={
                        item?.courses[0]
                          ? "/student/course/" + item.courses[0].uuid
                          : ""
                      }
                      progress={item.progress}
                      key={index}
                    />
                  )
              })}
            </div>
          </div>

        </section>
        <Footer setting={page?.setting} />
      </div>
    </div>

  );
};

export default Courses;
